module.exports = __webpack_public_path__ + "static/img/图层4.b0df1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层4.png
// module id = ZoSJ
// module chunks = 0